module.exports = __webpack_public_path__ + "static/media/Push1.b2b6956a.svg";